const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { projectType: { $ne: '' } }, { singleTenant: true }]
}

export default conditions
